import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  Label,
  Input,
  Button,
  FormGroup,
} from "reactstrap";
import Breadcrumbs from "components/Common/BreadcrumbTitle";
import { getOneEntity, getTaskById } from "http/fundLync/entityAndAddress.helper";
import { getDeal, getOneDeal } from "http/fundLync/deal.helper";
import { decryptedValue } from "common/utility";


const TaskDetails = () => {
  const { id } = useParams();
  const Id = atob(id);
  const navigate = useNavigate();
  const [tasks, setTasks] = useState([]);
  const [selectedEntity, setSelectedEntity] = useState([]);
  const [SelectedDeal, setSelectedDeal] = useState('');
  const user = decryptedValue(localStorage.getItem("user"));
 


    useEffect(() => {  

        getTaskById({ Id: Id })
        .then((response) => {
            const formattedDate = formatDate(response.dueDate.split(" ")[0]);
            const formattedTime = convertTo12HourFormat(response.dueTime);
            setTasks({ ...response, dueDate: formattedDate, dueTime:formattedTime});

            getOneEntity({ entityId: response.entityId })
          .then((response) => {
            if (response.code === 200 && response.status) {
              setSelectedEntity(response.data[0]);
            }
          })

          if(response.dealId === 'No Deals Found'){
            setSelectedDeal("-")
          }
          else{
            getOneDeal({ id: response.dealId })
            .then((response) => {
              setSelectedDeal(response?.dealName || '-');  
            })
          }

        })
        .catch((error) => {
          console.log(error)
        })
       


    }, [id]);

    function formatDate(dateString) {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); 
      const year = date.getFullYear();
      
  
      return `${day}-${month}-${year}`;
    }

    const convertTo12HourFormat = (time) => {
      let [hours, minutes] = time.split(':');
      hours = parseInt(hours, 10);
      const ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12 || 12; 
      return `${hours}:${minutes} ${ampm}`;
   };


  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Task Details" />
          <Row className="vertical-scroll">
            <Col xs="12">
              <Card>
                <CardBody>
                  <Row>
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                        <Label className="d-block entityDetails">Entity Name</Label>
                        <span className="mb-0 entityDetailsValue">{selectedEntity.entityName}</span>
                    </Col>
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                        <Label className="d-block entityDetails">Deal Name</Label>
                        <span className="mb-0 entityDetailsValue">{SelectedDeal}</span>
                    </Col>
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                        <Label className="d-block entityDetails">Task Name</Label>
                        <span className="mb-0 entityDetailsValue">{tasks.taskName}</span>
                    </Col>
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                        <Label className="d-block entityDetails">Task Type</Label>
                        <span className="mb-0 entityDetailsValue">{tasks.taskType}</span>
                    </Col>
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                        <Label className="d-block entityDetails">Assigned user</Label>
                        <span className="mb-0 entityDetailsValue">{tasks?.assignedToUser?.firstName + ' '+ tasks?.assignedToUser?.lastName}</span>
                    </Col>
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                        <Label className="d-block entityDetails">Task Status</Label>
                        <span className="mb-0 entityDetailsValue">{tasks.taskStatus}</span>
                    </Col>
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                        <Label className="d-block entityDetails">Task Priority</Label>
                        <span className="mb-0 entityDetailsValue">{tasks.taskPriority}</span>
                    </Col>
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                        <Label className="d-block entityDetails">Due date</Label>
                        <span className="mb-0 entityDetailsValue">{tasks.dueDate}</span>
                    </Col>
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                        <Label className="d-block entityDetails">Due Time</Label>
                        <span className="mb-0 entityDetailsValue">{tasks.dueTime}</span>
                    </Col>
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                        <Label className="d-block entityDetails">Task Reminder</Label>
                        <span className="mb-0 entityDetailsValue">{`${tasks.taskReminder} Before The Due Time`}</span>
                    </Col>
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                        <Label className="d-block entityDetails">Task Description</Label>
                        <span className="mb-0 entityDetailsValue">{tasks.taskDescription}</span>
                    </Col>
          
                  </Row>
                  <div className="d-flex justify-content-end">
                    <Button
                      onClick={handleCancel}
                       color='secondary'
                       outline
                      // style={{ backgroundColor: '#21aa47', borderColor: '#21aa47',marginTop:"10px" }}
                    >
                      Back
                    </Button>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default TaskDetails;
